import { Component } from "react";

/**
 * Generic error boundary. Without one, any uncaught render error unmounts the
 * whole React tree and the user sees a blank screen. Wrap volatile, data-driven
 * views (e.g. a saved run rendered from an arbitrary stored report) so a single
 * bad payload degrades to a readable message instead of blanking the app.
 */
export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    // Surface for diagnostics; the boundary keeps the rest of the app alive.
    // eslint-disable-next-line no-console
    console.error("ErrorBoundary caught an error:", error, info);
  }

  reset = () => this.setState({ error: null });

  render() {
    const { error } = this.state;
    if (error) {
      if (this.props.fallback) return this.props.fallback(error, this.reset);
      return (
        <div className="error-boundary">
          <p className="error-boundary-title">Something went wrong displaying this view.</p>
          <p className="error-boundary-detail">{error.message || String(error)}</p>
          {this.props.onReset && (
            <button
              className="error-boundary-btn"
              onClick={() => {
                this.reset();
                this.props.onReset();
              }}
            >
              ← Go back
            </button>
          )}
        </div>
      );
    }
    return this.props.children;
  }
}
